import { connect } from 'react-redux';
import { toggleScreens } from '../actions';
import ScreenSelection from '../components/ScreenSelection';
import { getScreenSelectionPage } from '../selectors';

const mapStateToProps = state => getScreenSelectionPage(state);

const mapDispatchToProps = dispatch => ({
    toggleScreens: (...args) => {
        dispatch(toggleScreens(...args));
    },
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(ScreenSelection);
